import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, styled, TextField, useTheme, useMediaQuery } from '@mui/material';
import LandingPageNav from '../../components/landingpage/LandingPageNav';

const StatesContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(3),
  paddingTop: theme.spacing(8), // Added top padding for small screens
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(15), // Original padding for larger screens
    paddingTop: theme.spacing(15), // Ensure top padding is consistent on larger screens
  },
}));


const StateButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
  marginTop: theme.spacing(2),
  maxWidth: '100%', // Ensures the container fits within small screen bounds
  '& > *': {
    margin: theme.spacing(1),
  },
}));

const StateButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1),
  minWidth: 100, // Adjusted for small screens
  height: 80, // Adjusted for small screens
  fontSize: '0.875rem', // Adjusted for small screens
  [theme.breakpoints.up('sm')]: {
    minWidth: 180, // Original minWidth for larger screens
    height: 120, // Original height for larger screens
    fontSize: '1rem', // Original fontSize for larger screens
  },
}));

const Banner = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.getContrastText(theme.palette.primary.main),
  padding: theme.spacing(2), // Adjusted padding for smaller screens
  width: '100%',
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4), // Original padding for larger screens
  },
}));

const InfoText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const SearchBarContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
}));

const states = ['Florida', 'Texas', 'Georgia', 'California', 'North Carolina', 'South Carolina', 'Missouri']; // Example states

function BranchLocations() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleStateSelect = (state) => {
    // Navigate to the state-specific page
    navigate(`/branchlocations/${state}`);
  };

  return (
    <>
      <LandingPageNav />
      <StatesContainer>
        <Banner>
          <Typography variant={isSmallScreen ? "h5" : "h4"} gutterBottom>
            Select a State to Find a Branch
          </Typography>
        </Banner>
        <StateButtonContainer>
          {states.map((state) => (
            <StateButton key={state} variant="contained" onClick={() => handleStateSelect(state)}>
              {state}
            </StateButton>
          ))}
        </StateButtonContainer>
        <InfoText>
          Don’t see a location near you? Call 816-867-5309 to speak with a Loan Officer who is licensed in your area.
        </InfoText>
      </StatesContainer>
      <SearchBarContainer>
        <TextField fullWidth label="Search for a location" variant="outlined" />
      </SearchBarContainer>
    </>
  );
}

export default BranchLocations;
